import { Locality } from '../../../shared/models/locality.model';
import { Serializable } from '../../../core/models/serializable';
export class CustomerLocationModel
  implements Serializable<CustomerLocationModel>
{
  fromObject(obj: any): CustomerLocationModel {
    Object.assign(this, obj);
    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public Id: number;
  public customerId: number;
  public locality: Locality;
  public countryId: string;
  public title: string;
  public address: string;
  public longtitude: number;
  public latitude: number;
  public createDate: Date;
  public isPending: boolean;
}
